import { generatePath } from "../generatePath";

export const path = {
  profileDoctor: {
    route: "/doctor-profile/:id",
    link: (id: string) => generatePath("/doctor-profile/:id", { id }),
  },
};
